import React from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import {
  Button,
  Card,
  Col,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Input,
  Label,
  Row,
  Table
} from 'reactstrap';

import styles from './style.module.scss';

import InfoIcon from '../../../assets/images/icons/info.svg';
import MoreIcon from '../../../assets/images/icons/more.svg';
import EditAllIcon from '../../../assets/images/icons/edit-all.svg';

import Environment from '../../../environment/Environment';
import { UpdateEditRestriction } from '../../../store/action-restriction/actions';
import { GetPlanId, IsNegative, NumberWithCommas, OneDecimalPlace, arrayMove } from '../../../helpers/Helpers';

import SuccessModal from '../../../components/Common/Modals/SuccessModal';
import Pagination from '../../../components/Common/pagination/pagination';
import Tooltip from '../../../components/Common/tooltip/tooltip';
import PageLoader from '../../../components/Common/loader/PageLoader';
import ActionCard from '../../../components/Footer/ActionCard';
import NoDataFound from '../../../components/Common/no-data-found/no-data-found';
import InitialMessage from '../../../components/Common/initial-message/initial-message';

import {
  ISKULevelPlanningData,
  ISKULevelPlanningPayload,
  ISKULevelPlanningRow
} from '../../../interfaces/sku-level-sales-plan.interface';
import {
  IColWidthPayload,
  IMeasureVisibilityPayload,
  IWeightMeasurePayload
} from '../../../interfaces/common.interface';
import {
  UpdateMeasureVisibility,
  DownloadTemplate,
  DownloadSkuVsFrozenSalesTemplate,
  DownloadSkuLevelTemplate,
  UpdateColWidth,
  UpdateColSequence, UpdateWeightMeasure
} from '../../../api-services/common.api';
import {
  FreezePlan,
  GetSKULevelSalesPlanData,
  ImportTemplate,
  InitializeSKU,
  UpdateData,
  CopyAspToPlan,
} from '../../../api-services/sku-level-sales-plan.api';
import HelpModal from '../../../components/Common/Modals/HelpModal';

interface OwnProps {
  history: any;
  isCallRequired: boolean;
  onLoadEnd: () => void;
  onUpdateStart: () => void;
  onUpdateEnd: () => void;
}

interface StateProps {
  history: any;
  isAllowed: boolean;
  filterData: any;
}

interface DispatchProps {
  UpdateEditRestriction: (isAllowed: boolean) => void;
}

type Props = StateProps & DispatchProps & OwnProps;

interface State {
  isAutoLoad:boolean;
  isLoading: boolean;
  originalDataSource: ISKULevelPlanningData;
  dataSource: ISKULevelPlanningData;
  selectedColumn: string;
  isColumnExpanded: boolean;
  isModalOpened: boolean;
  itemsCount: number;
  itemsPerPage: number;
  currentPage: number;
  totalPages: number;
  sortKey: string;
  sortDirection: string;
  isVisibilityMenuOpened: boolean;
  isMoreMenuOpened: boolean;
  isDownloadMenu: boolean;
  measureVisibilityList: any[];
  drag: {
    iniMouse: number;
    iniSize: number;
  };
  width: any;
  initializeList: {
    label: string;
    value: string;
  }[];
  isEditRestrictionAllowed: boolean;
  selectedInitialize: string;
  ratioList: string[];
  selectedRatio: string;
  referenceSKU: number;
  draggedPosition: number;
  successMessage: string;
  isInfoModalOpen: boolean;
  hasUnsavedEdits: boolean;
}

class SkuLevelSalesPlanTable extends React.Component<Props, State> {
  constructor(props) {
    super(props);

    this.state = {
      isAutoLoad:true,
      isLoading: true,
      originalDataSource: { columns: { measures: [], quarters: [] }, rows: [] },
      dataSource: { columns: { measures: [], quarters: [] }, rows: [] },
      selectedColumn: '',
      isColumnExpanded: true,
      isModalOpened: false,
      itemsCount: 0,
      itemsPerPage: Environment.ITEMS_PER_PAGE,
      currentPage: 1,
      totalPages: 0,
      sortKey: '',
      sortDirection: 'asc',
      isMoreMenuOpened: false,
      isDownloadMenu: false,
      isVisibilityMenuOpened: false,
      measureVisibilityList: [],
      drag: {
        iniMouse: 0,
        iniSize: 0
      },
      width: 0,
      initializeList: [
        { label: 'Copy LY', value: 'LY' },
        { label: 'Copy LQ', value: 'LQ' }
      ],
      isEditRestrictionAllowed: false,
      selectedInitialize: '',
      ratioList: ['LY', 'LQ', 'RECENT', 'FORECAST'],
      selectedRatio: 'RECENT',
      referenceSKU: 0,
      draggedPosition: 0,
      successMessage: '',
      isInfoModalOpen: false,
      hasUnsavedEdits: false,
    };

    this.toggleVisibilityMenu = this.toggleVisibilityMenu.bind(this);
    this.toggleMoreMenu = this.toggleMoreMenu.bind(this);
    this.toggleDownloadMenu = this.toggleDownloadMenu.bind(this);
  }

  toggleMoreMenu(): void {
    this.setState((prevState) => ({
      isMoreMenuOpened: !prevState.isMoreMenuOpened
    }));
  }

  componentDidMount(): void {
    //this.getSKULevelSalesPlan();
    const { state } = this.props.history.location;
    const fromSalesPlan = state?.fromSalesPlan ?? false; 
    if (fromSalesPlan) {
      this.getSKULevelSalesPlan(); // Load data ONLY if coming from Sales Plan
    } else {
      this.setState({ isLoading: false });
      this.props.onLoadEnd();
    }
    this.setState({
      width: document.getElementById('sku-level-sales-plan-table')?.offsetWidth || 0
    });
  }

  componentDidUpdate(prevProps, prevState): void {
    if (!prevProps.isCallRequired && this.props.isCallRequired) {
      this.setState({
        isLoading: true
      }, () => {
        this.getSKULevelSalesPlan();
      });
    }
  }

  downloadSKULevelFreezPlan(type: string): void {
    this.setState({ isLoading: true });

    const params = {
      type,
      userId: sessionStorage.getItem('userName'),
      planId: GetPlanId(this.props.history.location.pathname),
    };

    DownloadTemplate(params).then((response) => {
      let filename = '';
      switch (type) {
        case 'SalesPlanSKULevelFreeze':
          filename = 'sku_level_sales_plan_freeze.xlsx';
          break;
      }
      response.blob().then(blob => {
        let url = window.URL.createObjectURL(blob);
        let a = document.createElement('a');
        a.href = url;
        a.download = filename;
        a.click();
        this.setState({ isLoading: false });
      });
    });
  }

  downloadSkuVsFrozenSales(type: string): void {
    this.setState({ isLoading: true });

    const params = {
      type,
      userId: sessionStorage.getItem('userName'),
      planId: GetPlanId(this.props.history.location.pathname),
    };

    DownloadSkuVsFrozenSalesTemplate(params).then((response) => {
      let filename = '';
      switch (type) {
        case 'SKLP':
          filename = 'skuLevel_vs_frozenSales.xlsx';
          break;
        case 'RSKLP':
          filename = 'skuLevel_vs_frozenSKUSales.xlsx';
          break;

      }
      response.blob().then(blob => {
        let url = window.URL.createObjectURL(blob);
        let a = document.createElement('a');
        a.href = url;
        a.download = filename;
        a.click();
        this.setState({ isLoading: false });
      });
    });
  }

  downloadSkuLevelSalesPlan(downloadType: string): void {
    this.setState({ isLoading: true });

    const params = {
      downloadPlan: 'SPSKU',
      downloadType,
      userId: sessionStorage.getItem('userName'),
      planId: GetPlanId(this.props.history.location.pathname),
    };

    DownloadSkuLevelTemplate(params).then((response) => {
      let filename = '';
      switch (downloadType) {
        case 'UNIT':
          filename = 'SKU-Level-Sales-Plan-UNIT.xlsx';
          break;
        case 'VALUE':
          filename = 'SKU-Level-Sales-Plan-VALUE.xlsx';
          break;

      }
      response.blob().then(blob => {
        let url = window.URL.createObjectURL(blob);
        let a = document.createElement('a');
        a.href = url;
        a.download = filename;
        a.click();
        this.setState({ isLoading: false });
      });
    });
  }

  CopyAspToPlan(): void {
    const params = {
      userId: sessionStorage.getItem('userName'),
      planId: GetPlanId(this.props.history.location.pathname),
    };

    this.setState({ isLoading: true });

    CopyAspToPlan(params)
      .then(() => {
        this.props.onUpdateEnd();
        this.props.UpdateEditRestriction(false);
        this.setState({
          isModalOpened: true, 
          successMessage: 'ASP Copied successfully !!'
        });
      });
  }

  getSKULevelSalesPlan(): void {
    const params = {
      userId: sessionStorage.getItem('userName'),
    };

    GetSKULevelSalesPlanData(params)
      .then((res: ISKULevelPlanningData) => {
        this.setState({
          originalDataSource: !!res
            ? {
              columns: {
                ...res.columns,
                measures: res.columns.measures.map((measure) => {
                  return {
                    ...measure,
                    condition: '=',
                    value: '',
                    isVisible: measure.isVisible,
                    prevCheck: measure.isVisible,
                  };
                })
              },
              rows: res.rows.map((row) => {
                const measureDetails = row.measures.find((measure) => measure.name === 'qty_quota');
                const total = res.rows.reduce((rInit, row) => {
                  rInit += row.measures.reduce((mInit, measure) => {
                    mInit += measure.name === 'qty_quota' ? Math.round(measure.value) : 0;
                    return mInit;
                  }, 0);
                  return rInit;
                }, 0);

                const weightValue = (Math.round(measureDetails?.value) / total) * 100;
                const weightMeasureValue = OneDecimalPlace(weightValue);

                return {
                  ...row,
                  measures: row.measures.map((measure, mIdx: number) => {
                    const measureValue = typeof measure.value === 'number'
                      ? (
                        measure.name === 'weight_measure'
                          ? (weightMeasureValue || 0)
                          : (measure.datatype === 'percentage'
                          ? OneDecimalPlace(measure.value)
                          : Math.round(measure.value))
                      )
                      : measure.value;

                    return {
                      ...measure,
                      oldValue: measureValue,
                      value: measureValue,
                      isVisible: measure.name !== 'isSKU' ? measure.isVisible : false,
                      prevCheck: measure.isVisible,
                      isDisabled: false,
                      isEdited: false,
                      width: res.columns.measures[mIdx]?.width || 0,
                    };
                  }),
                  quarters: row.quarters.map((quarter) => {
                    return {
                      ...quarter,
                      weeks: quarter.weeks.map((week) => {
                        return {
                          ...week,
                          oldValue: week.value
                        };
                      })
                    };
                  }),
                  isWeightMeasureEdited: false,
                  isManualedit: false,
                  isEdited: false,
                };
              })
            }
            : { columns: { measures: [], quarters: [] }, rows: [] }
            ,isAutoLoad: false,
        }, () => {
          this.dataInit();
          this.props.onLoadEnd();
        });

        this.props.UpdateEditRestriction(false);
      });
  }

  dataInit(): void {
    this.state.originalDataSource.columns.measures.sort((x, y) => x.position - y.position);
    this.state.originalDataSource.rows.forEach((row) => {
      row.measures.sort((x, y) => x.position - y.position);
    });

    let items = this.state.originalDataSource.rows;
    const filteredColumnList = this.state.originalDataSource.columns.measures
      .filter((measure) => !!measure.value);

    filteredColumnList.forEach((data) => {
      items = items.filter((item) => {
        const idx = item.measures.findIndex((measure) => measure.name === data.id);

        if (idx > -1) {
          const matches = typeof item.measures[idx].value === 'string'
            && item.measures[idx].value.toLocaleUpperCase().match(data.value.toLocaleUpperCase());
          return typeof item.measures[idx].value === 'string'
            ? !!(matches && matches.length > 0)
            : (!!data.value
              ? SkuLevelSalesPlanTable.aggregateFn(data.condition, item.measures[idx].value, parseFloat(data.value))
              : true);
        }

        return false;
      });
    });

    if (!!this.state.sortKey) {
      items.sort((x, y) => {
        const mxIdx = x.measures.findIndex((m) => m.name === this.state.sortKey);
        const myIdx = y.measures.findIndex((m) => m.name === this.state.sortKey);

        const xField = !!x.measures[mxIdx].value
          ? (typeof x.measures[mxIdx].value === 'string' ? x.measures[mxIdx].value.toLocaleUpperCase() : x.measures[mxIdx].value)
          : '';
        const yField = !!y.measures[myIdx].value
          ? (typeof y.measures[myIdx].value === 'string' ? y.measures[myIdx].value.toLocaleUpperCase() : y.measures[myIdx].value)
          : '';

        if (xField === yField) {
          return 0;
        }
        if (this.state.sortDirection === 'asc' && xField < yField) {
          return -1;
        }
        if (this.state.sortDirection === 'desc' && xField > yField) {
          return -1;
        }

        return 1;
      });
    }

    const itemsCount = items.length;
    items = items.slice(this.state.itemsPerPage * (this.state.currentPage - 1), this.state.itemsPerPage * this.state.currentPage);
debugger;
    this.setState({
      itemsCount,
      totalPages: Math.ceil(this.state.originalDataSource.rows.length / this.state.itemsPerPage),
      dataSource: {
        columns: this.state.originalDataSource.columns,
        rows: items
      },
      isLoading: false
    }, () => {
      this.getVisibilityList();
    });
  }

  getVisibilityList(): void {
    const measureVisibilityList = this.state.originalDataSource.columns.measures
      .map((measure) => {
        return {
          id: measure.id,
          name: measure.name,
          total: measure.datatype === 'percentage' ? OneDecimalPlace(measure.total) : Math.round(measure.total),
          isVisible: measure.isVisible,
          prevCheck: measure.prevCheck === undefined ? measure.isVisible : measure.prevCheck
        };
      });

    this.setState({ measureVisibilityList });
  }

  toggleVisibilityMenu(): void {
    this.setState((prevState) => ({
      isVisibilityMenuOpened: !prevState.isVisibilityMenuOpened
    }));
  }

  toggleDownloadMenu(): void {
    this.setState((prevState) => ({
      isDownloadMenu: !prevState.isDownloadMenu
    }));
  }

  isColumnExpanded(): boolean {
    return this.state.dataSource.columns.quarters
      .reduce((qInit, quarter) => qInit || quarter.isExpanded, false);
  }

  onExpandColumn(quarterName: string, quarterIdx: number): void {
    this.state.dataSource.columns.quarters[quarterIdx].isExpanded =
      !this.state.dataSource.columns.quarters[quarterIdx].isExpanded;

    this.setState({
      dataSource: this.state.dataSource,
      selectedColumn: this.isColumnExpanded() ? quarterName : ''
    });
  }

  findNoOfCellBeforeSelectedColumn(): number {
    return this.state.dataSource.columns.quarters
      .findIndex((quarter) => quarter.name === this.state.selectedColumn);
  }

  findNoOfCellAfterSelectedColumn(): number {
    const totalQuarters = this.state.dataSource.columns.quarters.length;
    const selectedQuarterPosition = this.state.dataSource.columns.quarters
      .findIndex((quarter) => quarter.name === this.state.selectedColumn);
    return totalQuarters - selectedQuarterPosition - 1;
  }

  getColumnList() {
    return this.state.isColumnExpanded
      ? this.state.dataSource.columns.measures
      : this.state.dataSource.columns.measures.slice(0, 3);
  }

  getRowList(): ISKULevelPlanningRow[] {
    const copyOfRows = [...JSON.parse(JSON.stringify(this.state.dataSource.rows))];
    return this.state.isColumnExpanded
      ? copyOfRows
      : copyOfRows.map((row: ISKULevelPlanningRow) => ({
          ...row,
          measures: row.measures.slice(0, 4)
        }));
  }

  onUpdateQuarterCheckbox(rowIdx: number, quarterIdx: number, event): void {
    this.state.dataSource.rows[rowIdx].isEdited = true;
    this.state.dataSource.rows[rowIdx].quarters[quarterIdx].weeks.forEach((week) => {
      week.value = event.target.checked;
    });

    this.setState({ dataSource: this.state.dataSource });
  }

  onUpdateWeekCheckbox(rowIdx: number, quarterIdx: number, weekIdx: number): void {
    this.state.dataSource.rows[rowIdx].isEdited = true;
    this.state.dataSource.rows[rowIdx].quarters[quarterIdx].weeks[weekIdx].value =
      !this.state.dataSource.rows[rowIdx].quarters[quarterIdx].weeks[weekIdx].value;

    this.setState({ dataSource: this.state.dataSource });
  }

  isAllWeeksOfQuarterChecked(rowIdx: number, quarterIdx: number): boolean {
    return this.state.dataSource.rows[rowIdx].quarters[quarterIdx].weeks
      .reduce((acc, week) => acc && week.value, true);
  }

  updateMeasureValue(rowIdx: number, measureIdx: number, event): void {
    const value = parseFloat(event.target.value);
    this.state.dataSource.rows[rowIdx].measures[measureIdx].value = value;
    this.state.dataSource.rows[rowIdx].measures[measureIdx].isEdited = true;

    const planQuotaUnitIdx = this.state.dataSource.rows[rowIdx].measures
      .findIndex((measure) => measure.name === 'qty_quota');
    const planQuotaValueIdx = this.state.dataSource.rows[rowIdx].measures
      .findIndex((measure) => measure.name === 'val_quota');
    const planASPIdx = this.state.dataSource.rows[rowIdx].measures
      .findIndex((measure) => measure.name === 'plan_asp');
    const marginValueIdx = this.state.dataSource.rows[rowIdx].measures
      .findIndex((measure) => measure.name === 'margin');
    const marginPctIdx = this.state.dataSource.rows[rowIdx].measures
      .findIndex((measure) => measure.name === 'margin_pct');
    const weightMeasureIdx = this.state.dataSource.rows[rowIdx].measures
      .findIndex((measure) => measure.name === 'weight_measure');
    const escIdx = this.state.dataSource.rows[rowIdx].measures
      .findIndex((measure) => measure.name === 'esc$');

    /*When user edits Plan quota sales $*/
    if (measureIdx === planQuotaValueIdx) {
      this.state.dataSource.rows[rowIdx].isManualedit = true;

      const isPlanQuotaUnitEdited = this.state.dataSource.rows[rowIdx].measures[planQuotaUnitIdx].isEdited;
      const isPlanASPEdited = this.state.dataSource.rows[rowIdx].measures[planASPIdx].isEdited;
      const isWeightEdited = this.state.dataSource.rows[rowIdx].measures[weightMeasureIdx].isEdited;

      const planQuotaValue = value;
      const planQuotaUnitValue = this.state.dataSource.rows[rowIdx].measures[planQuotaUnitIdx].value;
      let planASPValue = this.state.dataSource.rows[rowIdx].measures[planASPIdx].value;
      const oldPlanASPValue = this.state.dataSource.rows[rowIdx].measures[planASPIdx].oldValue;
      const weightValue = this.state.dataSource.rows[rowIdx].measures[weightMeasureIdx].value;
      const escValue = this.state.dataSource.rows[rowIdx].measures[escIdx].value;
      const totalPlanQuotaUnit = this.getTotalMeasureCount('qty_quota', 'oldValue');

      if (isWeightEdited) {
        /*Update plan quota unit*/
        this.state.dataSource.rows[rowIdx].measures[planQuotaUnitIdx].value =
          Math.round(totalPlanQuotaUnit * (weightValue / 100));
        this.state.dataSource.rows[rowIdx].measures[planQuotaUnitIdx].isDisabled = true;

        /*Update plan asp*/
        planASPValue = planQuotaUnitValue !== 0 ? Math.round(planQuotaValue / planQuotaUnitValue) : 0;
        this.state.dataSource.rows[rowIdx].measures[planASPIdx].value = planASPValue;
        this.state.dataSource.rows[rowIdx].measures[planASPIdx].isDisabled = true;

        /*Update margin %*/
        const marginPct = escValue !== 0 ? OneDecimalPlace(((planASPValue - escValue) / planASPValue) * 100) : 0;
        this.state.dataSource.rows[rowIdx].measures[marginPctIdx].value = marginPct;

      } else if (isPlanQuotaUnitEdited) {
        /*Update weight*/
        this.state.dataSource.rows[rowIdx].measures[weightMeasureIdx].value =
          totalPlanQuotaUnit !== 0 ? Math.round((planQuotaUnitValue / totalPlanQuotaUnit) * 100) : 0;
        this.state.dataSource.rows[rowIdx].measures[weightMeasureIdx].isDisabled = true;

        /*Update plan asp*/
        planASPValue = planQuotaUnitValue !== 0 ? Math.round(planQuotaValue / planQuotaUnitValue) : 0;
        this.state.dataSource.rows[rowIdx].measures[planASPIdx].value = planASPValue;
        this.state.dataSource.rows[rowIdx].measures[planASPIdx].isDisabled = true;

        /*Update margin %*/
        const marginPct = escValue !== 0 ? OneDecimalPlace(((planASPValue - escValue) / planASPValue) * 100) : 0;
        this.state.dataSource.rows[rowIdx].measures[marginPctIdx].value = marginPct;
      } else if (isPlanASPEdited) {
        /*Update plan unit*/
        const unitValue = planASPValue !== 0 ? Math.round(planQuotaValue / planASPValue) : 0;
        this.state.dataSource.rows[rowIdx].measures[planQuotaUnitIdx].value = unitValue;
        this.state.dataSource.rows[rowIdx].measures[planQuotaUnitIdx].isDisabled = true;

        /*Update weight*/
        this.state.dataSource.rows[rowIdx].measures[weightMeasureIdx].value =
          totalPlanQuotaUnit !== 0 ? Math.round((unitValue / totalPlanQuotaUnit) * 100) : 0;
        this.state.dataSource.rows[rowIdx].measures[weightMeasureIdx].isDisabled = true;
      } else {
        /*Update plan quota unit*/
        const unitValue = oldPlanASPValue !== 0 ? Math.round(planQuotaValue / oldPlanASPValue) : 0;
        this.state.dataSource.rows[rowIdx].measures[planQuotaUnitIdx].value = unitValue;

        /*Update weight*/
        this.state.dataSource.rows[rowIdx].measures[weightMeasureIdx].value =
          totalPlanQuotaUnit !== 0 ? Math.round((unitValue / totalPlanQuotaUnit) * 100) : 0;
        this.state.dataSource.rows[rowIdx].measures[weightMeasureIdx].isDisabled = true;
      }

      /*Update Margin $*/
      const marginPctValue = this.state.dataSource.rows[rowIdx].measures[marginPctIdx].value;

      this.state.dataSource.rows[rowIdx].measures[marginValueIdx].value =
        Math.round((planQuotaValue * marginPctValue) / 100);
    }

    /*When user edits Plan ASP*/
    if (measureIdx === planASPIdx) {
      this.state.dataSource.rows[rowIdx].isManualedit = true;

      const isPlanQuotaValueEdited = this.state.dataSource.rows[rowIdx].measures[planQuotaValueIdx].isEdited;
      const isPlanQuotaUnitEdited = this.state.dataSource.rows[rowIdx].measures[planQuotaUnitIdx].isEdited;
      const isWeightEdited = this.state.dataSource.rows[rowIdx].measures[weightMeasureIdx].isEdited;

      const planASPValue = value;
      let planQuotaValue = this.state.dataSource.rows[rowIdx].measures[planQuotaValueIdx].value;
      const planQuotaUnit = this.state.dataSource.rows[rowIdx].measures[planQuotaUnitIdx].value;
      const weightValue = this.state.dataSource.rows[rowIdx].measures[weightMeasureIdx].value;
      const totalPlanQuotaUnit = this.getTotalMeasureCount('qty_quota', 'oldValue');
      const escValue = this.state.dataSource.rows[rowIdx].measures[escIdx].value;

      /*Update plan quota unit*/
      const unitValue = Math.round(totalPlanQuotaUnit * (weightValue / 100));
      this.state.dataSource.rows[rowIdx].measures[planQuotaUnitIdx].value = unitValue;

      if (isWeightEdited) {
        /*Update plan quota value*/
        this.state.dataSource.rows[rowIdx].measures[planQuotaValueIdx].value =
          Math.round(planASPValue * unitValue);
        this.state.dataSource.rows[rowIdx].measures[planQuotaValueIdx].isDisabled = true;

        /*Update plan quota unit*/
        this.state.dataSource.rows[rowIdx].measures[planQuotaUnitIdx].value =
          Math.round(totalPlanQuotaUnit * (weightValue / 100));
        this.state.dataSource.rows[rowIdx].measures[planQuotaUnitIdx].isDisabled = true;

      } else if (isPlanQuotaUnitEdited) {
        /*Update plan quota value*/
        planQuotaValue = Math.round(planQuotaUnit * planASPValue);
        this.state.dataSource.rows[rowIdx].measures[planQuotaValueIdx].value = planQuotaValue;
        this.state.dataSource.rows[rowIdx].measures[planQuotaValueIdx].isDisabled = true;

      } else if (isPlanQuotaValueEdited) {
        /*Update plan quota unit*/
        const unitValue = planASPValue !== 0 ? Math.round(planQuotaValue / planASPValue) : 0;
        this.state.dataSource.rows[rowIdx].measures[planQuotaUnitIdx].value = unitValue;
        this.state.dataSource.rows[rowIdx].measures[planQuotaUnitIdx].isDisabled = true;

        /*Update weight value*/
        this.state.dataSource.rows[rowIdx].measures[weightMeasureIdx].value =
          totalPlanQuotaUnit !== 0 ? Math.round((unitValue / totalPlanQuotaUnit) * 100) : 0;
        this.state.dataSource.rows[rowIdx].measures[weightMeasureIdx].isDisabled = true;

      } else {
        /*Update plan quota value*/
        this.state.dataSource.rows[rowIdx].measures[planQuotaValueIdx].value =
          Math.round(planASPValue * unitValue);
        // this.state.dataSource.rows[rowIdx].measures[planQuotaValueIdx].isDisabled = true;
      }

      /*Update Margin %*/
      const marginPctValue = planASPValue !== 0 ? OneDecimalPlace(((planASPValue - escValue) / planASPValue) * 100) : 0;
      this.state.dataSource.rows[rowIdx].measures[marginPctIdx].value = marginPctValue;
      this.state.dataSource.rows[rowIdx].measures[marginPctIdx].isDisabled = true;

      /*Update Margin $*/
      planQuotaValue = Math.round(planQuotaUnit * planASPValue);
      this.state.dataSource.rows[rowIdx].measures[marginValueIdx].value =
        Math.round((planQuotaValue * marginPctValue) / 100);
      this.state.dataSource.rows[rowIdx].measures[marginValueIdx].isDisabled = true;
    }

    /*When user edits Margin Value*/
    if (measureIdx === marginValueIdx) {
      const marginValue = value;
      const planQuotaValue = this.state.dataSource.rows[rowIdx].measures[planQuotaValueIdx].value;

      /*Update Margin % $*/
      const marginPctValue = planQuotaValue !== 0 ? OneDecimalPlace((marginValue / planQuotaValue) * 100) : 0;
      this.state.dataSource.rows[rowIdx].measures[marginPctIdx].value = marginPctValue;

      /*Update Plan ASP*/
      const escValue = this.state.dataSource.rows[rowIdx].measures[escIdx].value;
      const planASPValue = marginPctValue === 100 ? 0 : (100 * escValue) / (100 - marginPctValue);
      this.state.dataSource.rows[rowIdx].measures[planASPIdx].value = Math.round(planASPValue);

      this.state.dataSource.rows[rowIdx].measures[planASPIdx].isDisabled = true;
      this.state.dataSource.rows[rowIdx].measures[marginPctIdx].isDisabled = true;
    }

    /*When user edits Margin %*/
    if (measureIdx === marginPctIdx) {
      this.state.dataSource.rows[rowIdx].isManualedit = true;
      const marginPctValue = value;
      const escValue = this.state.dataSource.rows[rowIdx].measures[escIdx].value;

      const planASPValue = marginPctValue === 100 ? 0 : (100 * escValue) / (100 - marginPctValue);

      /*Update Plan quota value*/
      const planQuotaUnit = this.state.dataSource.rows[rowIdx].measures[planQuotaUnitIdx].value;
      const planQuotaValue = Math.round(planQuotaUnit * planASPValue);
      this.state.dataSource.rows[rowIdx].measures[planQuotaValueIdx].value = planQuotaValue;

      /*Update Margin $*/
      this.state.dataSource.rows[rowIdx].measures[marginValueIdx].value =
        Math.round((planQuotaValue * marginPctValue) / 100);

      /*Update Plan ASP*/
      this.state.dataSource.rows[rowIdx].measures[planASPIdx].value = Math.round(planASPValue);

      this.state.dataSource.rows[rowIdx].measures[planQuotaValueIdx].isDisabled = true;
      this.state.dataSource.rows[rowIdx].measures[planASPIdx].isDisabled = true;
      this.state.dataSource.rows[rowIdx].measures[marginValueIdx].isDisabled = true;
      this.state.dataSource.rows[rowIdx].measures[marginValueIdx].isEdited = true;
    }

    /*When user edits Plan quota unit*/
    if (measureIdx === planQuotaUnitIdx) {
      this.state.dataSource.rows[rowIdx].isManualedit = true;
      this.state.dataSource.rows[rowIdx].measures[weightMeasureIdx].isDisabled = true;

      const isPlanQuotaValueEdited = this.state.dataSource.rows[rowIdx].measures[planQuotaValueIdx].isEdited;
      const isPlanASPEdited = this.state.dataSource.rows[rowIdx].measures[planASPIdx].isEdited;
      const isMarginPctEdited = this.state.dataSource.rows[rowIdx].measures[marginPctIdx].isEdited;

      const planQuotaUnit = value;
      const planASPValue = this.state.dataSource.rows[rowIdx].measures[planASPIdx].value;
      const oldPlanASPValue = this.state.dataSource.rows[rowIdx].measures[planASPIdx].oldValue;
      let planQuotaValue = this.state.dataSource.rows[rowIdx].measures[planQuotaValueIdx].value;
      const totalPlanQuotaUnit = this.getTotalMeasureCount('qty_quota', 'oldValue');
      const escValue = this.state.dataSource.rows[rowIdx].measures[escIdx].value;

      if (isPlanQuotaValueEdited) {
        /*Update plan ASP value*/
        this.state.dataSource.rows[rowIdx].measures[planASPIdx].value =
          planQuotaUnit !== 0 ? Math.round(planQuotaValue / planQuotaUnit) : 0;
        this.state.dataSource.rows[rowIdx].measures[planASPIdx].isDisabled = true;

        /*Update weight value*/
        this.state.dataSource.rows[rowIdx].measures[weightMeasureIdx].value =
          totalPlanQuotaUnit !== 0 ? Math.round((planQuotaUnit / totalPlanQuotaUnit) * 100) : 0;
        this.state.dataSource.rows[rowIdx].measures[weightMeasureIdx].isDisabled = true;
      } else if (isPlanASPEdited) {
        /*Update plan quota value*/
        planQuotaValue = Math.round(planQuotaUnit * planASPValue);
        this.state.dataSource.rows[rowIdx].measures[planQuotaValueIdx].value = planQuotaValue;
        this.state.dataSource.rows[rowIdx].measures[planQuotaValueIdx].isDisabled = true;

        /*Update weight*/
        this.state.dataSource.rows[rowIdx].measures[weightMeasureIdx].value =
          totalPlanQuotaUnit !== 0 ? Math.round((planQuotaUnit / totalPlanQuotaUnit) * 100) : 0;
      } else if (isMarginPctEdited) {
        /*Update plan quota value*/
        planQuotaValue = Math.round(planQuotaUnit * planASPValue);
        this.state.dataSource.rows[rowIdx].measures[planQuotaValueIdx].value = planQuotaValue;
        this.state.dataSource.rows[rowIdx].measures[planQuotaValueIdx].isDisabled = true;
      } else {
        /*Update weight value*/
        this.state.dataSource.rows[rowIdx].measures[weightMeasureIdx].value =
          totalPlanQuotaUnit !== 0 ? Math.round((planQuotaUnit / totalPlanQuotaUnit) * 100) : 0;
        this.state.dataSource.rows[rowIdx].measures[weightMeasureIdx].isDisabled = true;

        /*Update plan quota value*/
        this.state.dataSource.rows[rowIdx].measures[planQuotaValueIdx].value =
          planQuotaUnit !== 0 ? Math.round(oldPlanASPValue * planQuotaUnit) : 0;
      }

      /*Update Margin $*/
      const marginPctValue = this.state.dataSource.rows[rowIdx].measures[marginPctIdx].value;
      this.state.dataSource.rows[rowIdx].measures[marginValueIdx].value =
        Math.round((planQuotaValue * marginPctValue) / 100);
    }

    /*When user edits Weight*/
    if (measureIdx === weightMeasureIdx) {
      this.state.dataSource.rows[rowIdx].isWeightMeasureEdited = true;
      this.state.dataSource.rows[rowIdx].measures[planQuotaUnitIdx].isDisabled = true;

      const isPlanQuotaValueEdited = this.state.dataSource.rows[rowIdx].measures[planQuotaValueIdx].isEdited;
      const isPlanASPEdited = this.state.dataSource.rows[rowIdx].measures[planASPIdx].isEdited;

      /*Update plan quota unit*/
      const weightValue = value;
      const totalPlanQuotaUnit = this.getTotalMeasureCount('qty_quota', 'oldValue');
      const planASPValue = this.state.dataSource.rows[rowIdx].measures[planASPIdx].value;
      const unitValue = Math.round((weightValue / 100) * totalPlanQuotaUnit);

      this.state.dataSource.rows[rowIdx].measures[planQuotaUnitIdx].value = unitValue;

      if (!isPlanQuotaValueEdited) {
        /*Update plan quota value*/
        this.state.dataSource.rows[rowIdx].measures[planQuotaValueIdx].value =
          Math.round(planASPValue * unitValue);
      }

      if (isPlanASPEdited) {
        this.state.dataSource.rows[rowIdx].measures[planQuotaValueIdx].isDisabled = true;
      }

      /*Update Margin $*/
      const planQuotaValue = Math.round(planASPValue * unitValue);
      const marginPctValue = this.state.dataSource.rows[rowIdx].measures[marginPctIdx].value;

      this.state.dataSource.rows[rowIdx].measures[marginValueIdx].value =
        Math.round((planQuotaValue * marginPctValue) / 100);
      // this.state.dataSource.rows[rowIdx].measures[planQuotaValueIdx].isDisabled = true;

      this.state.dataSource.rows[rowIdx].measures[weightMeasureIdx].isDisabled = false;
    }

    this.state.dataSource.rows[rowIdx].isEdited = true;
    this.setState({
      dataSource: this.state.dataSource,
      hasUnsavedEdits: true
    });
  }

  /*copyDataToPlan(): void {
    this.props.onUpdateStart();

    CopyDataToPlan(this.state.selectedInitialize)
      .then(response => {
        const statusCode = response.status;
        const data = statusCode !== 204 ? response.json() : [];

        return Promise.all([statusCode, data]).then(res => ({
          statusCode: res[0],
          data: res[1]
        }));
      })
      .then(() => {
        this.props.onUpdateEnd();
        this.props.UpdateEditRestriction(false);
      });
  }*/

  /*distributeSKU(): void {
    this.props.onUpdateStart();

    const payload = {
      rows: this.state.dataSource.rows
        .filter((row) => row.quarters
          .map((quarter) => quarter.weeks
            .some((week) => week.value !== week.oldValue)))
        .map((row) => Object.assign({}, row, {
          quarters: row.quarters
            .map((quarter) => Object.assign({}, quarter, {
              weeks: quarter.weeks.filter((week) => week.value !== week.oldValue)
            }))
        }))
        .filter((row) => !!row.quarters.filter((quarter) => !!quarter.weeks.length).length)
        .map((row) => {
          return {
            ...row,
            quarters: row.quarters.map((quarter) => {
              return {
                name: quarter.name,
                weeks: quarter.weeks.map((week) => {
                  return {
                    name: week.name,
                    value: week.value,
                  };
                })
              };
            })
          };
        })
    };

    DistributeSKU(payload)
      .then(response => {
        const statusCode = response.status;

        return Promise.all([statusCode]).then(res => ({
          statusCode: res[0]
        }));
      })
      .then((res: {
        statusCode: number
      }) => {
        if (res.statusCode === 200) {
          this.setState({
            isModalOpened: true,
            isColumnExpanded: true
          });
        }

        this.props.onUpdateEnd();
        this.props.UpdateEditRestriction(false);
      });
  }*/

  //While doing initialization , we are freezing the data in the API
  initializeSKU(): void {
    const params = {
      userId: sessionStorage.getItem('userName'),
      planId: GetPlanId(this.props.history.location.pathname),
      type: this.state.selectedRatio,
      referenceSKU: this.state.referenceSKU,
    };

    this.props.onUpdateStart();

    InitializeSKU(params)
      .then((res) => {
        if (!!res) {
          this.setState({ isModalOpened: true,
            successMessage: 'SKUs Initialized successfully and are now frozen.'
           });
        }

        this.props.onUpdateEnd();
        this.props.UpdateEditRestriction(false);
      });
  }

  freezePlan(): void {
    const payload: {rows: ISKULevelPlanningPayload[]} = {
      rows: this.state.originalDataSource.rows
        .filter((row) => !!row.isEdited)
        .map((row) => {
          return {
            isEdited: row.isEdited,
            isWeightMeasureEdited: row.isWeightMeasureEdited,
            isManualedit: row.isManualedit,
            measures: row.measures.map((measure) => {
              return {
                name: measure.name,
                value: measure.value,
                datatype: measure.datatype,
                isEdited: measure.isEdited,
              };
            }),
            quarters: row.quarters.map((quarter) => {
              return {
                name: quarter.name,
                weeks: quarter.weeks.map((week) => {
                  return {
                    name: week.name,
                    value: week.value,
                    oldValue: week.oldValue,
                  };
                })
              };
            })
          };
        })
    };
    
    const params = {
      userId: sessionStorage.getItem('userName'),
      planId: GetPlanId(this.props.history.location.pathname),
      isWeekEdit:false,
    };

    this.props.onUpdateStart();

    FreezePlan(payload, params)
      .then((res) => {
        if (!!res) {
          this.props.onUpdateEnd();
          this.props.UpdateEditRestriction(false);

          this.setState({
                  isModalOpened: true, 
                  successMessage: 'Your changes have been successfully saved and are now frozen.'
                });
        }else{
          this.props.onUpdateEnd();
          this.props.UpdateEditRestriction(false);
        }
      });
  }

  saveData(isFreezeRequired: boolean): void {
    const payload: {rows: ISKULevelPlanningPayload[]} = {
      rows: this.state.originalDataSource.rows
        .filter((row) => !!row.isEdited)
        .map((row) => {
          return {
            isEdited: row.isEdited,
            isWeightMeasureEdited: row.isWeightMeasureEdited,
            isManualedit: row.isManualedit,
            measures: row.measures.map((measure) => {
              return {
                name: measure.name,
                value: measure.value,
                datatype: measure.datatype,
                isEdited: measure.isEdited,
              };
            }),
            quarters: row.quarters.map((quarter) => {
              return {
                name: quarter.name,
                weeks: quarter.weeks.map((week) => {
                  return {
                    name: week.name,
                    value: week.value,
                    oldValue: week.oldValue,
                  };
                })
              };
            })
          };
        })
    };

    const params = {
      userId: sessionStorage.getItem('userName'),
      planId: GetPlanId(this.props.history.location.pathname),
      type: this.state.selectedRatio,
      referenceSKU: this.state.referenceSKU,
    };

    this.props.onUpdateStart();

    UpdateData(payload, params)
      .then((res) => {
        if (!!res) {
          this.setState({
            currentPage: 1
          }, () => {
            if (isFreezeRequired) {
              this.freezePlan();
            } else {
              this.props.onUpdateEnd();
              this.props.UpdateEditRestriction(false);
            }
          });
        }
      });
  }

  saveButtonValidity(): boolean {
    const { rows } = this.state.dataSource;

    const validMeasureNames = new Set([
      'qty_quota',
      'val_quota',
      'plan_asp',
      'margin',
      'margin_pct',
      'weight_measure'
    ]);

    return rows.length > 0 && rows.every(row =>
      row.measures.filter(measure => measure.isEdited)
        .every(measure => {
          if (validMeasureNames.has(measure.name)) {
            switch (measure.name) {
              case 'weight_measure':
                return this.getTotalEditedMeasureCount(measure.name) > 100;
              case 'margin':
              case 'margin_pct':
              case 'plan_asp':
                return false;
              default:
                return this.getTotalEditedMeasureCount(measure.name) > this.getTotalMeasureCount(measure.name, 'oldValue');
            }
          }
          return false; // Skip invalid measure names
        })
    );
  }

  saveFreezeButtonValidity(): boolean {
    const { rows } = this.state.dataSource;
    const total = this.getTotalMeasureCount('qty_quota', 'value');
    return rows.length > 0 && total > 0;
  }

  static addTextEllipsis(measureName: string): Object {
    return [
      'product_code',
      'product_description',
      'brand_level2_desc',
      'graphics',
      'graphics_memory',
      'processor',
      'storage_size'
    ].indexOf(measureName) !== -1
      ? {
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
      }
      : {};
  }

  handlePageChange(pageNumber: number): void {
    this.setState({
      currentPage: pageNumber
    }, () => {
      this.dataInit();
    });
  }

  verticalCheckboxValidity(wIdx: number): boolean {
    const count = this.state.originalDataSource.rows.reduce((rInit, row) => {
      rInit += row.quarters.reduce((qInit, quarter) => {
        qInit += quarter.weeks[wIdx].value ? 1 : 0;
        return qInit;
      }, 0);
      return rInit;
    }, 0);

    return count === 1;
  }

  verticalCheckboxCount(wIdx: number): number {
    return this.state.originalDataSource.rows.reduce((rInit, row) => {
      rInit += row.quarters.reduce((qInit, quarter) => {
        qInit += quarter.weeks[wIdx].value ? 1 : 0;
        return qInit;
      }, 0);
      return rInit;
    }, 0);
  }

  calculateTotalSKU(isSKU: boolean): number {
    return this.state.originalDataSource.rows.reduce((rInit, row) => {
      rInit += row.measures.reduce((mInit, measure) => {
        mInit += (measure.name === 'isSKU' && measure.value === isSKU) ? 1 : 0;
        return mInit;
      }, 0);
      return rInit;
    }, 0);
  }

  updateAggregateSelect(colIdx: number, value: string): void {
    this.state.originalDataSource.columns.measures[colIdx].condition = value;

    this.setState({
      originalDataSource: this.state.originalDataSource
    }, () => {
      this.columnSearchHandler(colIdx, this.state.originalDataSource.columns.measures[colIdx].value);
    });
  }

  static aggregateFn(symbol: string, a: number, b: number) {
    switch (symbol) {
      case '=':
        return a === b;
      case '<':
        return a < b;
      case '>':
        return a > b;
      case '<=':
        return a <= b;
      case '>=':
        return a >= b;
    }
  };

  columnSearchHandler(colIdx: number, value: string): void {
    this.state.originalDataSource.columns.measures[colIdx].value = value;

    this.setState({
      originalDataSource: this.state.originalDataSource
    }, () => {
      this.dataInit();
    });
  }

  doSort(columnName: string): void {
    const data = this.state.originalDataSource.columns.measures.find((col) => col.id === columnName);

    this.setState({
      sortKey: !!data ? data.id : '',
      sortDirection: data?.id === this.state.sortKey
        ? (this.state.sortDirection === 'asc' ? 'desc' : 'asc')
        : 'asc'
    }, () => {
      this.dataInit();
    });
  }

  addColumnWidth(colIdx: number, width: number): Object {
    const style = { width: `${width}px` };

    if (colIdx === 0) {
      return { ...style, left: 0 };
    }

    if (colIdx === 1) {
      return { ...style, left: `${this.getColumnList().length > 0 ? this.getColumnList()[0].width : 0}px` };
    }

    return style;
  }

  onUpdateVisibilityCheck(measureIdx: number): void {
    this.state.measureVisibilityList[measureIdx].isVisible =
      !this.state.measureVisibilityList[measureIdx].isVisible;
    this.state.originalDataSource.columns.measures[measureIdx].isVisible =
      !this.state.originalDataSource.columns.measures[measureIdx].isVisible;
    this.state.originalDataSource.rows.forEach((row) => {
      row.measures[measureIdx].isVisible = !row.measures[measureIdx].isVisible;
    });

    this.setState({
      originalDataSource: this.state.originalDataSource,
      measureVisibilityList: this.state.measureVisibilityList
    }, () => {
      this.getVisibilityList();
    });
  }

  checkVisibilitySaveButton(): boolean {
    return this.state.measureVisibilityList
      .every((measure) => measure.isVisible === measure.prevCheck);
  }

  updateMeasureVisibility(): void {
    const payload: IMeasureVisibilityPayload = {
      visibility: this.state.measureVisibilityList
        .map((measure) => {
          return {
            name: measure.name,
            isVisible: measure.isVisible
          };
        })
    };

    const params = {
      userId: sessionStorage.getItem('userName'),
      planId: GetPlanId(this.props.history.location.pathname),
    };

    this.setState({ isLoading: true });

    UpdateMeasureVisibility(payload, params)
      .then((res) => {
        if (!!res) {
          this.setState({
            isModalOpened: true,
            successMessage:'Measure visibility updated successfully !!!'
          }, () => {
            this.getSKULevelSalesPlan();
          });
        }
      });
  }

  handleStart(e, col: string): void {
    let iniMouse = e.clientX;
    let iniSize = document.getElementById(`${col}`)?.offsetWidth;

    this.setState({
      drag: { iniSize: iniSize || 0, iniMouse }
    });
  }

  handleMove(e, col: string, mIdx: number): void {
    if (e.clientX) {
      let iniMouse = this.state.drag.iniMouse;
      let iniSize = this.state.drag.iniSize;
      let endMouse = e.clientX;

      let endSize = iniSize + (endMouse - iniMouse);
      const colEle = document.getElementById(`${col}`)!;
      const tableEle = document.getElementById('sku-level-sales-plan-table')!;

      if (endSize < 120) {
        return;
      }

      colEle.style.width = `${endSize}px`;
      tableEle.style.width = `${this.state.width + endSize}px`;

      this.state.dataSource.columns.measures[mIdx].width = endSize;
      this.setState({ dataSource: this.state.dataSource });
    }
  }

  updateColWidth(): void {
    const payload: IColWidthPayload = {
      widthData: this.state.dataSource.columns.measures
        .map((measure) => {
          return {
            name: measure.name,
            width: measure.width
          };
        })
    };

    const params = {
      userId: sessionStorage.getItem('userName'),
      planId: GetPlanId(this.props.history.location.pathname),
    };
    this.setState({ isLoading: true });

    UpdateColWidth(payload, params)
      .then((res) => {
        if (!!res) {
          this.setState({
            isModalOpened: true
          }, () => {
            this.getSKULevelSalesPlan();
          });
        }
      });
  }

  resetCalculations(): void {
    this.setState({hasUnsavedEdits:false});
    this.getSKULevelSalesPlan();
  }

  getTotalMeasureCount(measureName: string, type: string): number {
    const total = this.state.originalDataSource.rows.reduce((rInit, row) => {
      rInit += row.measures.reduce((mInit, measure) => {
        mInit += measure.name === measureName ? measure[type] : 0;
        return mInit;
      }, 0);
      return rInit;
    }, 0);

    return (measureName === 'weight_measure' && type === 'oldValue') ? Math.round(total) : Math.round(total);
  }

  getTotalEditedMeasureCount(measureName: string): number {
    const total = this.state.originalDataSource.rows.reduce((rInit, row) => {
      rInit += row.measures.filter((measure) => measure.isEdited)
        .reduce((mInit, measure) => {
          mInit += measure.name === measureName ? measure.value : 0;
          return mInit;
        }, 0);
      return rInit;
    }, 0);

    return measureName === 'weight_measure' ? Math.round(total) : Math.round(total);
  }

  onColumnDrag(position: number): void {
    this.setState({ draggedPosition: position });
  }

  /* onColumnDrop(position: number): void {
    const draggedPosition = this.state.draggedPosition;
    const droppedPosition = position;

    const draggedIndex = this.getColumnList().findIndex((col) => col.position === draggedPosition);
    const droppedIndex = this.getColumnList().findIndex((col) => col.position === droppedPosition);

    this.state.originalDataSource.columns.measures[draggedIndex].position = droppedPosition;
    this.state.originalDataSource.columns.measures[droppedIndex].position = draggedPosition;

    this.state.originalDataSource.columns.measures.sort((x, y) => x.position - y.position);

    this.state.originalDataSource.rows.forEach((row) => {
      row.measures[draggedIndex].position = droppedPosition;
      row.measures[droppedIndex].position = draggedPosition;

      row.measures.sort((x, y) => x.position - y.position);
    });

    this.dataInit();
  } */

  onColumnDrop(position: number): void {
  const draggedPosition = this.state.draggedPosition;
  const droppedPosition = position;

  const columns = [...this.getColumnList()];
  const draggedIndex = columns.findIndex(col => col.position === draggedPosition);
  const droppedIndex = columns.findIndex(col => col.position === droppedPosition);

  if (draggedIndex === -1 || droppedIndex === -1 || draggedIndex === droppedIndex) return;

  //Move columns
  const updatedMeasures = arrayMove(this.state.originalDataSource.columns.measures, draggedIndex, droppedIndex);

  //Reassign positions
  updatedMeasures.forEach((col, idx) => {
    col.position = idx;
  });
debugger;
  //Update row measures
  this.state.originalDataSource.rows.forEach((row) => {
    row.measures = arrayMove(row.measures, draggedIndex, droppedIndex);
    row.measures.forEach((measure, idx) => {
      measure.position = idx;
    });
  });

  //Assign updated measures back
  this.state.originalDataSource.columns.measures = updatedMeasures;

  //Re-render
  this.dataInit();

  this.setState({ draggedPosition: -1 });
}

 reorderColumnsAndRowValues<T>(
  columnData: T[],
  rowData: any[][],
  fromIndex: number,
  toIndex: number
): { newColumns: T[], newRows: any[][] } {
  const newColumns = arrayMove(columnData, fromIndex, toIndex);
  const newRows = rowData.map(row => arrayMove(row, fromIndex, toIndex));
  return { newColumns, newRows };
}



  updateColSequence(): void {
    const payload = this.state.originalDataSource.columns.measures.map((measure) => {
      return {
        id: measure.id,
        position: measure.position,
      };
    });

    const params = {
      userId: sessionStorage.getItem('userName'),
      planId: GetPlanId(this.props.history.location.pathname),
    };

    this.props.onUpdateStart();

    UpdateColSequence(payload, params)
      .then((res) => {
        if (!!res) {
          this.setState({
            isModalOpened: true,
            currentPage: 1
          }, () => {
            this.props.onUpdateEnd();
            this.props.UpdateEditRestriction(false);
          });
        }
      });
  }

  importTemplate = (event): void => {
    let formData = new FormData();
    formData.append('file', event.target['files'][0], event.target['files'][0].name);

    const params = {
      userId: sessionStorage.getItem('userName'),
      planId: GetPlanId(this.props.history.location.pathname),
    };

    this.props.onUpdateStart();

    ImportTemplate(formData, params)
      .then(() => {
        this.updateWeightMeasure();
      });
  };

  updateWeightMeasure = (): void => {
    const payload: IWeightMeasurePayload = {
      planId: GetPlanId(this.props.history.location.pathname) || '1',
      userId: sessionStorage.getItem('userName') || '',
      uploadType: 'SLSP',
      total: this.getTotalMeasureCount('qty_quota', 'oldValue'),
      skus: this.state.originalDataSource.rows.map(row => {
        const productCodeIdx = row.measures.findIndex(m => m.name === 'product_code');
        const planUnitIdx = row.measures.findIndex(m => m.name === 'qty_quota');
        return {
          sku: row.measures[productCodeIdx].value,
          value: row.measures[planUnitIdx].value,
        };
      }),
    };

    UpdateWeightMeasure(payload)
      .then(() => {
        this.props.onUpdateEnd();
      });
  };

  downloadTemplate(type: string): void {
    this.setState({ isLoading: true });

    const params = {
      type,
      planId: GetPlanId(this.props.history.location.pathname) || 1,
      userId: sessionStorage.getItem('userName')
    };

    DownloadTemplate(params).then((response) => {
      let filename = '';
      switch (type) {
        case 'units':
          filename = 'sales_plan_units.xlsx';
          break;
        case 'revenue':
          filename = 'sales_plan_revenue.xlsx';
          break;
        case 'frozen':
          filename = 'freeze_sales_plan.xlsx';
          break;
      }
      response.blob().then(blob => {
        let url = window.URL.createObjectURL(blob);
        let a = document.createElement('a');
        a.href = url;
        a.download = filename;
        a.click();
        this.setState({ isLoading: false });
      });
    });
  }

  disableActionBtn(): boolean {
    return this.state.originalDataSource.columns.quarters.some(q => q.isPast);
  }

  render(): React.ReactNode {

    if (this.state.isAutoLoad) {
      return <InitialMessage/>;
    }

    if (this.state.originalDataSource.rows.length === 0) {
      return <NoDataFound/>;
    }

    return (
      <React.Fragment>

        <PageLoader
          status={this.state.isLoading}
        />

        <Card className="section-header-card">
          <Row>
            <Col md={3} className="align-self-center">
              <div className="d-flex">
                <p className="table-title">{this.props.filterData.level} -
                  <span className="sub-title"> {this.props.filterData.products}</span>
                </p>
                <p onClick={() => this.setState(() => this.setState({ isInfoModalOpen: true }))}>
                    <img src={InfoIcon} alt="info-icon" className="cursor-pointer"/>
                </p>
              </div>
            </Col>

            {/*<Col md={3}>
              <div className="custom-form-container">
                <label htmlFor={'initialize'} className="custom-form-label">Initialize</label>
                <select
                  id="initialize"
                  className="custom-drop-down-field custom-select-width"
                  onChange={(e) => {
                    this.props.isAllowed
                      ? this.setState({ isEditRestrictionAllowed: true })
                      : this.setState({ isEditRestrictionAllowed: false });
                    this.setState({
                      selectedInitialize: e.target.value
                    }, () => {
                      ['LY', 'LQ'].indexOf(this.state.selectedInitialize) !== -1 &&
                      this.copyDataToPlan();
                    });
                  }}
                >
                  <option value="">Select</option>
                  {
                    this.state.initializeList.map((initialize, initializeIdx) => (
                      <option
                        key={initializeIdx}
                        value={initialize.value}
                      >
                        {initialize.label}
                      </option>
                    ))
                  }
                </select>
              </div>
            </Col>*/}

            <Col md={{ offset: 1, size: 4 }} className="align-self-center">
              <div className="custom-form-container">
                <label className="custom-form-label me-3">Ratio: </label>
                {
                  this.state.ratioList.map((ratio: string) => (
                    <div
                      key={ratio}
                      className="d-flex align-items-center"
                    >
                      <Input
                        id={ratio}
                        name="Phasing Toggle"
                        type="radio"
                        checked={ratio === this.state.selectedRatio}
                        onChange={() => this.setState({ selectedRatio: ratio })}
                      />
                      <Label for={ratio} className="custom-form-label">{ratio}</Label>
                    </div>
                  ))
                }
              </div>
            </Col>

            <Col md={2} className="align-self-center d-flex justify-content-end">
              <div className="custom-form-container">
                <Input
                  id="Reference SKU"
                  type="checkbox"
                  onChange={() => this.setState({ referenceSKU: this.state.referenceSKU === 0 ? 1 : 0 })}
                />
                <Label for="Reference SKU" className="custom-form-label cursor-pointer ms-2">Reference SKU</Label>
              </div>
            </Col>

            <Col md={2} className="align-self-center">
              <div className="d-flex align-items-center justify-content-end">
                <Tooltip
                  content={'Edit All'}
                  direction={'top'}
                >
                  <div
                    className="action-btn"
                    onClick={() => {
                      if (this.props.isAllowed) {
                        this.setState({ isEditRestrictionAllowed: true });
                      } else {
                        //this.props.history.replace('/sku-level-sales-plan-edit-all?filter');
                        this.props.history.replace({
                          pathname: '/sku-level-sales-plan-edit-all',
                          search: '?filter',          //  HO--I180
                          state: { fromSalesPlan: true } 
                        });
                      }
                    }}
                  >
                    <img
                      src={EditAllIcon}
                      alt="edit-icon"
                      height={'24px'}
                      className="edit-icon-position"
                    />
                  </div>
                </Tooltip>

                <Tooltip
                  content={'Save column width'}
                  direction={'top'}
                >
                  <i
                    className="mdi mdi-arrow-expand-horizontal font-size-18 cursor-pointer px-2"
                    style={{ verticalAlign: 'middle' }}
                    onClick={() => this.updateColWidth()}
                  />
                </Tooltip>

                <Tooltip
                  content={'Save Column Sequence'}
                  direction={'top'}
                >
                  <i
                    className="ri-drag-drop-line font-size-18 cursor-pointer px-2"
                    style={{ verticalAlign: 'middle' }}
                    onClick={() => this.updateColSequence()}
                  />
                </Tooltip>

                <Dropdown
                  isOpen={this.state.isVisibilityMenuOpened}
                  toggle={this.toggleVisibilityMenu}
                  className="d-inline-block user-dropdown px-2"
                >
                  <Tooltip
                    content={'Measure Visibility Setting'}
                    direction={'top'}
                  >
                    <DropdownToggle tag="button" className="btn action-btn waves-effect p-0">
                      <i className="ri-list-settings-line font-size-18"/>
                    </DropdownToggle>
                  </Tooltip>

                  <DropdownMenu className="custom-dropdown-menu dropdown-menu-end">
                    <React.Fragment>
                      <div className="dropdown-menu-box-sm">
                        {
                          this.state.measureVisibilityList.map((measure, mIdx: number) => (
                            <React.Fragment key={mIdx}>
                              {
                                ['product_code', 'product_description'].indexOf(measure.id) === -1 &&
                                <DropdownItem
                                  toggle={false}
                                  className={`${(measure.isVisible !== measure.prevCheck) && 'dropdown-item-changed'}`}
                                >
                                  <div className="d-flex align-items-center">
                                    <Input
                                      id={mIdx.toString()}
                                      type="checkbox"
                                      checked={measure.isVisible}
                                      onChange={() => this.onUpdateVisibilityCheck(mIdx)}
                                      className="me-2 flex-shrink-0"
                                    />
                                    <Label for={mIdx.toString()} className="cursor-pointer mb-0">
                                      {measure.name}
                                    </Label>
                                  </div>
                                </DropdownItem>
                              }
                              {
                                this.state.measureVisibilityList.length - 1 !== mIdx &&
                                [0, 1].indexOf(mIdx) === -1 &&
                                <DropdownItem divider/>
                              }
                            </React.Fragment>
                          ))
                        }
                      </div>
                      <div className="py-1 text-right">
                        <Button
                          color={'primary'}
                          disabled={this.checkVisibilitySaveButton()}
                          className="btn btn-sm btn-primary ms-3 mx-3"
                          onClick={() => this.updateMeasureVisibility()}
                        >
                          Save
                        </Button>
                      </div>
                    </React.Fragment>
                  </DropdownMenu>
                </Dropdown>

                <Dropdown
                  isOpen={this.state.isMoreMenuOpened}
                  toggle={this.toggleMoreMenu}
                  className="d-inline-block user-dropdown"
                >
                  <Tooltip content={'More'} direction={'top'}>
                    <DropdownToggle tag="button" className="btn action-btn waves-effect p-0">
                      <img src={MoreIcon} alt="more-icon"/>
                    </DropdownToggle>
                  </Tooltip>

                  <DropdownMenu className="dropdown-menu-end">

                    <DropdownItem
                      disabled={this.disableActionBtn()}
                      onClick={() => this.initializeSKU()}
                    >Initialize</DropdownItem>
                    <DropdownItem divider/>

                    <div className="position-relative">
                      <DropdownItem
                        disabled={this.disableActionBtn()}
                        onClick={() => {
                          if (this.props.isAllowed) {
                            this.setState({ isEditRestrictionAllowed: true });
                          }
                        }}
                      >
                        Import
                      </DropdownItem>
                      <input
                        type="file"
                        accept=".csv,
                          application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,
                          application/vnd.ms-excel"
                        disabled={this.disableActionBtn()}
                        onChange={(e) => {
                          this.importTemplate(e);
                          this.toggleMoreMenu();
                        }}
                      />
                    </div>

                    <DropdownItem divider/>

                    <Dropdown
                      isOpen={this.state.isDownloadMenu}
                      toggle={this.toggleDownloadMenu}
                      className="d-inline-block user-dropdown"
                      direction="end"
                    >
                      <DropdownToggle className={styles['dropdown-toggle']}>Download Template</DropdownToggle>
                      <DropdownMenu id={styles['downloadDropdown']}>
                        <DropdownItem onClick={() => this.downloadSkuLevelSalesPlan('UNIT')}>
                          Units
                        </DropdownItem>
                        <DropdownItem onClick={() => this.downloadSkuLevelSalesPlan('VALUE')}>
                          Revenue
                        </DropdownItem>
                      </DropdownMenu>
                    </Dropdown>

                    <DropdownItem divider/>

                    {/*<DropdownItem
                    disabled={!this.saveButtonValidity()}
                    onClick={() => this.saveData()}
                  >Save</DropdownItem>
                  <DropdownItem divider/>

                  <DropdownItem
                    onClick={() => this.freezePlan()}
                  >Freeze Plan</DropdownItem>
                  <DropdownItem divider/>*/}

                    {/*<DropdownItem
                    onClick={() => this.distributeSKU()}
                  >Distribute</DropdownItem>
                  <DropdownItem divider/>*/}

                    <DropdownItem
                      onClick={() => this.downloadSKULevelFreezPlan('SalesPlanSKULevelFreeze')}
                    >Download SKU Freeze Plan</DropdownItem>
                    <DropdownItem divider/>

                    <DropdownItem
                      onClick={() => this.downloadSkuVsFrozenSales('SKLP')}
                    >Download SKU Vs Frozen Sales Plan</DropdownItem>
                    <DropdownItem divider/>

                    <DropdownItem
                      disabled={this.disableActionBtn()}
                      onClick={() => this.CopyAspToPlan()}
                    >Copy ASP to Plan</DropdownItem>
                    <DropdownItem divider/>

                  </DropdownMenu>

                </Dropdown>
              </div>
            </Col>
          </Row>
        </Card>

        <div className={`table-responsive table-outline custom-table sticky-table ${styles['sku-level-table-container']}`}>
          <Table id="sku-level-sales-plan-table" className="mb-0" style={{ tableLayout: 'fixed' }}>
            <thead>
            <tr>
              {
                this.getColumnList().map((measure, mIdx: number) => (
                  <React.Fragment key={mIdx}>
                    {
                      measure.isVisible &&
                      <th
                        id={measure.id}
                        data-position={measure.position}
                        draggable="true"
                        onDragStart={() => this.onColumnDrag(measure.position)}
                        onDragOver={(e) => e.preventDefault()}
                        onDrop={() => this.onColumnDrop(measure.position)}
                        className={`${mIdx < 2 ? styles['sticky-col'] : 'position-relative'} cursor-pointer`}
                        style={
                          Object.assign(
                            {},
                            this.addColumnWidth(mIdx, measure.width),
                            { cursor: 'grab' }
                          )
                        }
                      >
                        <div
                          className="dragger-line"
                          draggable={true}
                          onDragStart={(e) => this.handleStart(e, measure.id)}
                          onDrag={(e) => this.handleMove(e, measure.id, mIdx)}
                        />
                        <span onClick={() => this.doSort(measure.id)}>
                            {measure.name}
                          {
                            this.state.sortKey === measure.id &&
                            <span className="px-1">{this.state.sortDirection === 'asc' ? '↑' : '↓'}</span>
                          }
                          </span>
                      </th>
                    }
                  </React.Fragment>
                ))
              }
              {
                this.state.dataSource.columns.quarters.map((quarter, qIdx: number) => (
                  <th
                    key={qIdx}
                    colSpan={quarter.isExpanded ? quarter.weeks.length : 1}
                    className="v-middle"
                    style={{ width: !this.isColumnExpanded() ? '120px' : '1100px' }}
                  >
                     <span className="toggle-col">
                       {quarter.name}
                       <i
                         className={`${quarter.isExpanded
                           ? 'ri-checkbox-indeterminate-fill'
                           : 'ri-add-box-fill'} ms-sm-2`}
                         onClick={() => this.onExpandColumn(quarter.name, qIdx)}
                       />
                     </span>
                  </th>
                ))
              }
            </tr>
            <tr>
              {
                this.getColumnList().map((measure, mIdx: number) => (
                  <React.Fragment key={mIdx}>
                    {
                      measure.isVisible &&
                      <th
                        className={`${mIdx < 2 ? styles['sticky-col'] : ''} cursor-pointer`}
                        style={this.addColumnWidth(mIdx, measure.width)}
                      >
                        {
                          [
                            'product_code',
                            'product_description',
                            'brand_level2_desc',
                            'new_product_date',
                            'discontinued_date',
                            'graphics',
                            'graphics_memory',
                            'processor',
                            'storage_size',
                          ].indexOf(measure.id) === -1 &&
                          <select
                            className="aggregate-select"
                            style={{ width: '25px' }}
                            onChange={(e) => this.updateAggregateSelect(mIdx, e.target.value)}
                          >
                            <option value="=">=</option>
                            <option value="<">&lt;</option>
                            <option value=">">&gt;</option>
                            <option value="<=">≤</option>
                            <option value=">=">≥</option>
                          </select>
                        }
                        <input
                          type={'text'}
                          className="editable-input"
                          style={{
                            width: [
                              'product_code',
                              'product_description',
                              'brand_level2_desc',
                              'new_product_date',
                              'discontinued_date',
                              'graphics',
                              'graphics_memory',
                              'processor',
                              'storage_size',
                            ].indexOf(measure.id) !== -1
                              ? '100%'
                              : '70%',
                            textAlign: 'left'
                          }}
                          onChange={(e) => this.columnSearchHandler(mIdx, e.target.value)}
                          value={measure.value}
                        />
                      </th>
                    }
                  </React.Fragment>
                ))
              }
              {
                this.state.dataSource.columns.quarters.map((quarter, qIdx: number) => (
                  <th
                    key={qIdx}
                    colSpan={quarter.isExpanded ? quarter.weeks.length : 1}
                    className="v-middle"
                  />
                ))
              }
            </tr>
            <tr>
              {
                this.state.measureVisibilityList
                  .filter((measure) => measure.isVisible)
                  .map((measure, idx) => (
                    <th
                      key={idx}
                      className={`text-right ${[0, 1].indexOf(idx) !== -1 && styles['sticky-col']}`}
                      style={this.addColumnWidth(idx, this.getColumnList().length > 0 ? this.getColumnList()[idx].width : 0)}
                    >
                      {
                        idx === 0 &&
                        `SKU: ${this.calculateTotalSKU(true)}, PH: ${this.calculateTotalSKU(false)}`
                      }
                      {
                        ['weight_measure', 'val_quota', 'qty_quota', 'margin'].indexOf(measure.id) !== -1
                          ? `(${NumberWithCommas(this.getTotalMeasureCount(measure.id, 'oldValue'))} /
                          ${NumberWithCommas(this.getTotalEditedMeasureCount(measure.id))}) ${measure.id === 'weight_measure' ? '%' : ''}`
                          : (measure.total === -1 ? '' : NumberWithCommas(Math.round(measure.total))
                          )
                      }
                      {
                        measure.id === 'margin_pct' &&
                        `(${NumberWithCommas(OneDecimalPlace((this.getTotalMeasureCount('margin', 'oldValue') / this.getTotalMeasureCount('val_quota', 'oldValue')) * 100))} /
                          ${NumberWithCommas(this.getTotalEditedMeasureCount(measure.id))})`
                      }
                      {
                        measure.id === 'plan_asp' &&
                        `(${NumberWithCommas(Math.round(this.getTotalMeasureCount('val_quota', 'oldValue') / this.getTotalMeasureCount('qty_quota', 'oldValue')))} /
                          ${NumberWithCommas(this.getTotalEditedMeasureCount(measure.id))})`
                      }
                      {
                        measure.id === 'esc$' &&
                        NumberWithCommas(Math.round(this.getTotalMeasureCount('esc$', 'oldValue') / this.state.originalDataSource.rows.length))
                      }
                      {
                        measure.id === 'sk_actual_sales_u' &&
                        NumberWithCommas(this.getTotalMeasureCount('sk_actual_sales_u', 'oldValue'))
                      }
                      {
                        measure.id === 'sk_actual_sales_v' &&
                        NumberWithCommas(this.getTotalMeasureCount('sk_actual_sales_v', 'oldValue'))
                      }
                      {
                        measure.id === 'incoming_inv_qty' &&
                        NumberWithCommas(this.getTotalMeasureCount('incoming_inv_qty', 'oldValue'))
                      }
                      {
                        measure.id === 'inv_closing_qty' &&
                        NumberWithCommas(this.getTotalMeasureCount('inv_closing_qty', 'oldValue'))
                      }
                      {
                        measure.id === 'available_stock' &&
                        NumberWithCommas(this.getTotalMeasureCount('available_stock', 'oldValue'))
                      }
                      {
                        measure.id === 'act_margin' &&
                        NumberWithCommas(this.getTotalMeasureCount('act_margin', 'oldValue'))
                      }
                      {
                        measure.id === 'act_margin_pct' &&
                        NumberWithCommas(OneDecimalPlace(this.getTotalMeasureCount('act_margin', 'oldValue') /
                          this.getTotalMeasureCount('qty_quota', 'oldValue')))
                      }
                      {
                        measure.id === 'asp' &&
                        NumberWithCommas(OneDecimalPlace(this.getTotalMeasureCount('sk_actual_sales_v', 'oldValue') /
                          this.getTotalMeasureCount('sk_actual_sales_u', 'oldValue')))
                      }
                    </th>
                  ))
              }
              {
                this.isColumnExpanded() &&
                this.state.dataSource.columns.quarters.map((quarter, qIdx: number) => (
                  <React.Fragment key={qIdx}>
                    {
                      quarter.weeks.map((week: string, wIdx: number) => (
                        <th
                          key={wIdx}
                          className="text-center"
                        >
                          {this.verticalCheckboxCount(wIdx)}
                        </th>
                      ))
                    }
                  </React.Fragment>
                ))
              }
              {
                !this.isColumnExpanded() && <th/>
              }
            </tr>
            {
              this.isColumnExpanded() &&
              <React.Fragment>
                <tr>
                  {
                    (Array.from(Array(
                      this.state.isColumnExpanded
                        ? (this.state.measureVisibilityList.filter((measure) => measure.isVisible === true).length)
                        : 4)))
                      .map((measure, mIdx) => (
                        <th
                          key={mIdx}
                          className={`${mIdx < 2 ? styles['sticky-col'] : ''}`}
                          style={this.addColumnWidth(mIdx, this.getColumnList()[mIdx].width)}
                        />
                      ))
                  }
                  {
                    (Array.from(Array(this.findNoOfCellBeforeSelectedColumn())))
                      .map((o, idx) => (
                        <th key={idx}/>
                      ))
                  }
                  {
                    this.state.dataSource.columns.quarters.map((quarter, qIdx: number) => (
                      <React.Fragment key={qIdx}>
                        {
                          quarter.weeks.map((week: string, wIdx: number) => (
                            <th key={wIdx}>{week}</th>
                          ))
                        }
                      </React.Fragment>
                    ))
                  }
                  {
                    (Array.from(Array(this.findNoOfCellAfterSelectedColumn())))
                      .map((o, idx) => (
                        <th key={idx}/>
                      ))
                  }
                </tr>
              </React.Fragment>
            }
            </thead>
            <tbody>
            {
              this.getRowList().map((row, rIdx: number) => (
                <tr key={rIdx}>
                  {
                    row.measures
                      .map((measure, mIdx: number) => (
                        <React.Fragment key={mIdx}>
                          {
                            measure.isVisible &&
                            <td
                              className={`${typeof measure.value === 'string' ? 'text-left' : 'text-right'}
                                ${mIdx < 2 ? styles['sticky-col'] : ''}`}
                              style={
                                Object.assign(
                                  {},
                                  SkuLevelSalesPlanTable.addTextEllipsis(measure.name),
                                  this.addColumnWidth(mIdx, measure.width)
                                )
                              }
                            >
                              {/*<span style={SkuLevelSalesPlanTable.addTextEllipsis(measure.name)}>*/}
                              {
                                ['weight_measure', 'val_quota', 'plan_asp', 'margin_pct', 'qty_quota', 'margin'].indexOf(measure.name) !== -1
                                  ? <input
                                    type={'number'}
                                    className={
                                      `${(measure.isEdited)
                                        ? 'editable-input-new'
                                        : 'editable-input'}
                                        ${(!row.isEditable || measure.isDisabled) && ' readonly-input'}
                                        ${IsNegative(measure.value) && ' error-input'}`
                                    }
                                    readOnly={(!row.isEditable || measure.isDisabled)}
                                    disabled={row.quarters[0].isPast}
                                    onChange={(e) => this.updateMeasureValue(rIdx, mIdx, e)}
                                    value={measure.value || 0}
                                    style={{ width: 100 }}
                                  />
                                  : <React.Fragment>
                                    {['val_quota', 'plan_asp', 'margin', 'asp', 'sk_ly_sales_v', 'sk_lq_sales_v', 'margin_lq', 'margin_ly'].indexOf(measure.name) !== -1 ? '$' : ''}
                                    {
                                      ['new_product_date', 'discontinued_date'].indexOf(measure.name) !== -1
                                        ? (!!measure.value ? measure.value.split(' ')[0] : '')
                                        : ['product_code', 'product_description'].indexOf(measure.name) !== -1 ? measure.value : NumberWithCommas(measure.value)
                                    }
                                    {['margin_pct', 'margin_pct_lq', 'margin_pct_ly', 'act_margin_pct', 'l4w'].indexOf(measure.name) !== -1 ? '%' : ''}
                                  </React.Fragment>
                              }
                              {/*</span>*/}
                            </td>
                          }
                        </React.Fragment>
                      ))
                  }
                  {
                    !this.isColumnExpanded()
                      ? row.quarters.map((quarter, qIdx: number) => (
                        <td key={qIdx} className="text-center">
                          <Input
                            type="checkbox"
                            checked={this.isAllWeeksOfQuarterChecked(rIdx, qIdx)}
                            disabled={true}
                            onChange={(e) => this.onUpdateQuarterCheckbox(rIdx, qIdx, e)}
                          />
                        </td>
                      ))
                      : row.quarters.map((quarter, qIdx: number) => (
                        <React.Fragment key={qIdx}>
                          {
                            quarter.weeks.map((week, wIdx: number) => (
                              <td key={wIdx}
                                  className={(
                                    new Date(week?.weekStartDate || '').getTime() >= new Date(row.measures[row.measures.findIndex((measure) => measure.name === 'discontinued_date')].value).getTime() ? 'bg-gray' : ''
                                  ) + ' text-center'}
                              >
                                <Input
                                  type="checkbox"
                                  checked={week.value}
                                  // disabled={week.value ? this.verticalCheckboxValidity(wIdx) : false}
                                  disabled={true}
                                  onChange={() => this.onUpdateWeekCheckbox(rIdx, qIdx, wIdx)}
                                />
                              </td>
                            ))
                          }
                        </React.Fragment>
                      ))
                  }
                </tr>
              ))
            }
            </tbody>
          </Table>
        </div>

        {/* <Row>
          <Col md={12}>
            <Pagination
              currentPage={this.state.currentPage}
              totalCount={this.state.itemsCount}
              pageSize={this.state.itemsPerPage}
              onPageChange={(page) => this.handlePageChange(page)}
            />
          </Col>
        </Row> */}

        <SuccessModal
          isOpen={this.state.isModalOpened}
          toggle={() => this.setState({ isModalOpened: !this.state.isModalOpened })}
          message={this.state.successMessage}
        />

{(this.state.hasUnsavedEdits) && (
        <ActionCard
          onCancel={() => this.resetCalculations()}
          onSave={() => this.saveData(false)}
          onSaveAndFreeze={() => this.saveData(true)}
          isSaveDisabled={this.saveButtonValidity()}
          isSaveAndFreezeDisabled={!this.saveFreezeButtonValidity()}
        />
)}

        {<HelpModal
          isOpen={this.state.isInfoModalOpen}
          toggle={() => this.setState({ isInfoModalOpen: !this.state.isInfoModalOpen })}
          docUrl={`Content/Topics_sales_plan/Managing SKU Level Sales Plan.htm`}
        />}

      </React.Fragment>
    );
  }
}

const mapStateToProps = (state: any): StateProps => {
  return {
    ...state.EditRestriction,
    filterData: state.FilterData
  };
};

export default connect<StateProps, DispatchProps, OwnProps>
(mapStateToProps, {
  UpdateEditRestriction
})(withRouter(SkuLevelSalesPlanTable));
